export default function UserCard({ user }) {
    const getInitials = (surname = '', lastname = '') => {
        const s = surname ? surname[0] : '';
        const l = lastname ? lastname[0] : '';
        return `${s}${l}`.toUpperCase();
    };

    const typeInfo = {
        Student: {
            color: "bg-green-500",
            icon: <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0l-.062-.377a51.714 51.714 0 01.676-3.423l.062.377zm15.482 0l.062-.377a51.714 51.714 0 00-.676-3.423l-.062.377z" />,
        },
        Teacher: {
            color: "bg-blue-500",
            icon: <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292M18 7.5v.75m-6-3v.75m-6-3v.75m0 10.5a8.973 8.973 0 016-2.292" />,
        },
        Admin: {
            color: "bg-purple-500",
            icon: <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.602-3.751A11.977 11.977 0 0012 2.75a11.977 11.977 0 00-5.398 2.986z" />,
        },
    };

    const specificInfo = typeInfo[user.__typename] || {};

    return (
        <a className="group wrap block w-full text-left bg-white rounded-xl border-2 border-neutral-200 transition-all duration-100 hover:border-neutral-300" href={`/admin/users/${user.id}`}>
            <div className="p-4">
                <div className="flex items-center space-x-4">
                    <div className={`flex-shrink-0 w-12 h-12 rounded-full ${specificInfo.color} text-white flex items-center justify-center font-bold text-lg`}>
                        {getInitials(user.surname, user.lastname)}
                    </div>
                    <div className="flex-grow min-w-0">
                        <h3 className="font-bold text-neutral-800 truncate" title={`${user.surname} ${user.lastname}`}>
                            {user.lastname.toUpperCase()} {user.surname}
                        </h3>
                        <p className="text-sm text-neutral-500 truncate" title={`@${user.username}`}>
                            @{user.username}
                        </p>
                    </div>
                    <div>
                        <p className={`px-3 py-1 text-xs font-semibold rounded-full ${specificInfo.color} bg-opacity-20 text-neutral-800`}>
                            {
                                user.__typename === 'Student' ? 'Schüler' :
                                user.__typename === 'Teacher' ? 'Lehrer' :
                                user.__typename === 'Admin' ? 'Administrator' :
                                'Unbekannt'
                            }
                        </p>
                    </div>
                </div>
            </div>
            {(user.class || (user.classes && user.classes.length > 0)) && (
            <div className="bg-neutral-50 p-4 rounded-b-xl border-t-2 border-neutral-200">
                    <div className="flex flex-wrap gap-2">
                        {user.__typename === 'Student' && (
                            <>
                                {user.boarding && (
                                    <span className="inline-flex items-center py-1 px-2 rounded-md text-xs bg-black/5 text-neutral-600 font-bold">
                                        Internat
                                    </span>
                                )}
                                {user.class && (
                                    <span className="inline-flex items-center py-1 px-2 rounded-md text-xs font-medium bg-black/5 text-neutral-600">
                                        {user.class.name}
                                    </span>
                                )}
                                {user.groups && user.groups.length > 0 && user.groups.map(g => (
                                    <span key={g.id} className="inline-flex items-center py-1 px-2 rounded-md text-xs font-medium bg-black/5 text-neutral-600">
                                       {g.name}
                                    </span>
                                ))}
                            </>
                        )}
                        {user.__typename === 'Teacher' && (
                            <>
                                {user.isBoarding && (
                                    <span className="inline-flex items-center py-1 px-2 rounded-md text-xs bg-black/5 text-neutral-600 font-bold">
                                        Erzieher
                                    </span>
                                )}
                                {user.classes.map(c => (
                                    <span key={c.id} className="inline-flex items-center py-1 px-2 rounded-md text-xs font-medium bg-black/5 text-neutral-600">
                                       {c.name}
                                    </span>
                                ))}
                                
                            </>
                        )}
                    </div>
            </div>
            )}
        </a>
    );
}